var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"crumb"},[_c('div',{staticClass:"crumb-1",class:{
      active: 0 !== _vm.settingPage,
    },on:{"click":function($event){return _vm.clickCrumb(1)}}},[_vm._v(" 1 设置考试信息 "),_c('div',{staticClass:"crumb-1-right",class:{
        active: 0 !== _vm.settingPage,
      }})]),_c('div',{staticClass:"crumb-2",class:{
      active: 1 !== _vm.settingPage,
    },on:{"click":function($event){return _vm.clickCrumb(2)}}},[_vm._v(" 2 选择试卷 "),_c('div',{staticClass:"crumb-2-left",class:{
        active: 1 !== _vm.settingPage,
      }}),_c('div',{staticClass:"crumb-2-right",class:{
        active: 1 !== _vm.settingPage,
      }})]),_c('div',{staticClass:"crumb-3",class:{
      active: 3 === _vm.settingPage || 4 === _vm.settingPage,
    },on:{"click":function($event){return _vm.clickCrumb(3)}}},[_vm._v(" 3 发布 "),_c('div',{staticClass:"crumb-3-left",class:{
        active: 3 === _vm.settingPage || 4 === _vm.settingPage,
      }})])])
}
var staticRenderFns = []

export { render, staticRenderFns }